import useUser from "../hooks/useUser"

export default function RequireAuth({ children }) {
  const { status } = useUser()

  if (status === "loading") {
    return (
      <div className="max-w-4xl mx-auto py-12 px-4 text-center text-[color:var(--color-muted)] dark:text-muted-light">
        Loading…
      </div>
    )
  }

  if (status === "anonymous") {
    // Hard navigation to /login so Rails can run the OAuth flow + store_location.
    window.location.href = "/login"
    return null
  }

  return children
}
